import { signInWithEmailAndPassword, signOut, getAuth } from "firebase/auth";
import { auth } from "../services/firebaseSetup";

export const firebaseLogin = async (email, password) => {
  try {
    const userCredential = await signInWithEmailAndPassword(auth, email, password);

    const user = userCredential.user;

    // 🔑 Get ID token (if needed for backend auth)
    const idToken = await user.getIdToken();

    return {
      success: true,
      user,
      idToken
    };
  } catch (error) {
    console.error("[firebaseLogin] Error during login:", error);
    return {
      success: false,
      error: error.message
    };
  }
};


export async function validateCredentials(email, password) {
  console.log("[validateCredentials] Starting credential validation...");
  const auth = getAuth();
  console.log("[validateCredentials] Got Firebase Auth instance.");

  try {
    console.log(`[validateCredentials] Attempting sign in for email: ${email}`);
    await signInWithEmailAndPassword(auth, email, password);
    console.log("[validateCredentials] Sign in successful. Now signing out...");
    await signOut(auth); // Logout immediately
    console.log("[validateCredentials] Sign out successful.");
    return { success: true };
  } catch (error) {
    console.error("[validateCredentials] Error during credential validation:", error);
    return {
      success: false,
      error:"Invalid credentials",
    };
  }
}